import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'

import styles from './FileNames.module.scss'

interface IFileNamesProps {
  fileListVisibility?: boolean
  names?: string[]
  onFileRemove?: (fileName: string) => Promise<void>
}

export const FileNames = ({ fileListVisibility, names, onFileRemove }: IFileNamesProps) => {
  const [removingFile, setRemovingFile] = useState<string | null>(null)

  return fileListVisibility ? (
    <Flex>
      {names &&
        names.map((name) => (
          <Flex gap={'none'} alignItems={'center'} key={name}>
            <p data-testid={'url-file-list-item'} className={styles.filesListNames}>
              {name}
            </p>
            {onFileRemove ? (
              <Button
                __testId={'fileNames-list-remove-button'}
                disabled={removingFile ? removingFile !== name : false}
                loading={removingFile === name}
                variant={'text'}
                iconButton={'kbase kbase-delete'}
                color={'grey'}
                onClick={async () => {
                  setRemovingFile(name)
                  await onFileRemove(name)
                  setRemovingFile(null)
                }}
              />
            ) : null}
          </Flex>
        ))}
    </Flex>
  ) : null
}
